import i18next from 'i18next';

export default function initI18n(): void {
  i18next.addResourceBundle('en', 'book-ui', {
    resourceLinks: 'Resource Links',
    editDescription: 'Edit Description',
    saveDescription: 'Save Description',
    publishSelectedBooks: 'Publish selected books',
    unpublishSelectedBooks: 'Unpublish selected books',
    deleteSelectedBooks: 'Delete selected books',
    deleteBook: 'Delete book',
    resetStatus: 'Reset status',
    goodreadsList: 'Goodreads List',
    descriptionUpdated: 'Description updated successfully',
    bookPublished: 'Book published',
    bookDeleted: 'Book deleted',
    booksDeletedCount: '{{count}} book deleted',
    booksDeletedCount_plural: '{{count}} books deleted',
    statusReset: 'Status reset',
    bookUnpublished: 'Book unpublished',
    deleteBookConfirm: 'Are you sure you want to delete "{{title}}"? This action cannot be undone.',
    resetStatusConfirm:
      'Are you sure you want to reset the status of "{{title}}"? This will set it back to draft and clear all processing timestamps.',
    cannotBeUndoneSuffix: ' This action cannot be undone.',
    book: 'Book',
    books: 'Books',
    delete: 'Delete',
    cancel: 'Cancel',
  });
}
